import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '..';
import * as fromTripManager from './trip-manager.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');

// feature slice
const getTripManagerSubState = createSelector(getSharedAuditState, state => state.tripManager);

// state slices
const getPostedAircraftTripSkeletonsState = createSelector(
  getTripManagerSubState,
  state => state.postedAircraftTripSkeletons
);
const getPostedAircraftTripAuditState = createSelector(
  getTripManagerSubState,
  state => state.postedAircraftTripAudit
);
const getPostedAircraftTripLegAuditState = createSelector(
  getTripManagerSubState,
  state => state.postedAircraftTripLegAudit
);

// posted aircraft trip skeletons
export const getPostedAircraftTripSkeletonsLoading = createSelector(
  getPostedAircraftTripSkeletonsState,
  state => state.loading
);
export const getPostedAircraftTripSkeletonsLoaded = createSelector(
  getPostedAircraftTripSkeletonsState,
  state => state.loaded
);
export const getPostedAircraftTripSkeletons = createSelector(
  getPostedAircraftTripSkeletonsState,
  fromTripManager.postedAircraftTripSkeletonsSelectors.selectAll
);

// posted aircraft trip audit
export const getPostedAircraftTripAuditLoading = createSelector(
  getPostedAircraftTripAuditState,
  state => state.loading
);
export const getPostedAircraftTripAuditLoaded = createSelector(
  getPostedAircraftTripAuditState,
  state => state.loaded
);
export const getPostedAircraftTripAudit = createSelector(
  getPostedAircraftTripAuditState,
  fromTripManager.postedAircraftTripAuditSelectors.selectAll
);

// posted aircraft trip leg audit
export const getPostedAircraftTripLegAuditLoading = createSelector(
  getPostedAircraftTripLegAuditState,
  state => state.loading
);
export const getPostedAircraftTripLegAuditLoaded = createSelector(
  getPostedAircraftTripLegAuditState,
  state => state.loaded
);
export const getPostedAircraftTripLegAudit = createSelector(
  getPostedAircraftTripLegAuditState,
  fromTripManager.postedAircraftTripLegAuditSelectors.selectAll
);
